import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useFetcherWithAbort } from 'shared/hooks/use-fetcher-with-abort';
import { LECTURE_API } from '../../curriculum/api/lecture-api';
import { LectureId } from '../../curriculum/types/lecture-interface';
import { CreateModuleInterface, ModuleId, ModuleInterface } from '../../curriculum/types/module-interface';
import { CourseEditApiInterface, CourseId } from '../../types/course-interface';
import { CREATE_LIGHT_COURSE_API, getLightCourseCreateLecturePath, getLightCourseCreateModulePath, getLightCourseDeleteLecturePath, getLightCoursePatchOptionsPath, getLightCourseUpdateLecturePath, getLightCourseUpdateModulePath } from '../light-course-api';
import { getDefaultLightCourseContent, getDefaultLightCourseLectureContent } from '../light-course-default-content';
import { CreateLightCourseInterface, CreateLightCourseLectureInterface, CreateLightCourseModuleInterface, CreateLightCourseResponseInterface, LightCourseCurriculumInterface, LightCourseLectureInterface, PatchLightCourseOptionsInterface, UpdateLightCourseLectureInterface } from '../light-course-interface';
export const useLightCourseActions = () => {
  const $ = _c(43);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: createLightCourseFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.patch
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: patchLightCourseOptionsFetcher
  } = useFetcherWithAbort(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.post
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: createLightCourseModuleFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.post
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    fetcher: createLightCourseLectureFetcher
  } = useFetch(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      method: RequestMethodsEnum.delete
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    fetcher: deleteLightCourseLectureFetcher
  } = useFetch(t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      method: RequestMethodsEnum.post
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    fetcher: activateLightCourseLectureFetcher
  } = useFetch(t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      method: RequestMethodsEnum.put
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const {
    fetcher: updateLightCourseLectureFetcher
  } = useFetch(t6);
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      method: RequestMethodsEnum.patch
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const {
    fetcher: patchLightCourseLectureFetcher
  } = useFetcherWithAbort(t7);
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      method: RequestMethodsEnum.put
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const {
    fetcher: putLightCourseModuleFetcher
  } = useFetcherWithAbort(t8);
  let t9;
  if ($[9] !== putLightCourseModuleFetcher) {
    t9 = async (moduleId, data) => await putLightCourseModuleFetcher(getLightCourseUpdateModulePath(moduleId), data);
    $[9] = putLightCourseModuleFetcher;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const updateLightCourseModule = t9;
  let t10;
  if ($[11] !== createLightCourseFetcher) {
    t10 = data_0 => createLightCourseFetcher(CREATE_LIGHT_COURSE_API, data_0);
    $[11] = createLightCourseFetcher;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const createLightCourse = t10;
  let t11;
  if ($[13] !== createLightCourse) {
    t11 = async domainId => await createLightCourse({
      name: getDefaultLightCourseContent().name,
      description: getDefaultLightCourseContent().description,
      domainId
    });
    $[13] = createLightCourse;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const createLightCourseWithDefaultValues = t11;
  let t12;
  if ($[15] !== patchLightCourseOptionsFetcher) {
    t12 = async (courseId, data_1, t13) => {
      const requestKey = t13 === undefined ? "lightCourseOptions" : t13;
      return await patchLightCourseOptionsFetcher(getLightCoursePatchOptionsPath(courseId), data_1, undefined, requestKey);
    };
    $[15] = patchLightCourseOptionsFetcher;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const patchLightCourseOptions = t12;
  let t13;
  if ($[17] !== createLightCourseModuleFetcher) {
    t13 = async (courseId_0, data_2) => await createLightCourseModuleFetcher(getLightCourseCreateModulePath(courseId_0), data_2);
    $[17] = createLightCourseModuleFetcher;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const createLightCourseModule = t13;
  let t14;
  if ($[19] !== createLightCourseLectureFetcher) {
    t14 = async (moduleId_0, data_3) => await createLightCourseLectureFetcher(getLightCourseCreateLecturePath(moduleId_0), data_3);
    $[19] = createLightCourseLectureFetcher;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const createLightCourseLecture = t14;
  let t15;
  if ($[21] !== createLightCourseLecture) {
    t15 = async moduleId_1 => await createLightCourseLecture(moduleId_1, getDefaultLightCourseLectureContent());
    $[21] = createLightCourseLecture;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const createLightCourseLectureWithDefaultValues = t15;
  let t16;
  if ($[23] !== deleteLightCourseLectureFetcher) {
    t16 = async lectureId => {
      await deleteLightCourseLectureFetcher(getLightCourseDeleteLecturePath(lectureId));
    };
    $[23] = deleteLightCourseLectureFetcher;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  const deleteLightCourseLecture = t16;
  let t17;
  if ($[25] !== activateLightCourseLectureFetcher) {
    t17 = (update, id) => activateLightCourseLectureFetcher(`${LECTURE_API}/${id}/${update}`);
    $[25] = activateLightCourseLectureFetcher;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  const activateLightCourseLecture = t17;
  let t18;
  if ($[27] !== updateLightCourseLectureFetcher) {
    t18 = (id_0, lecture) => updateLightCourseLectureFetcher(getLightCourseUpdateLecturePath(id_0), lecture);
    $[27] = updateLightCourseLectureFetcher;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  const updateLightCourseLecture = t18;
  let t19;
  if ($[29] !== patchLightCourseLectureFetcher) {
    t19 = async (id_1, lecture_0, t20) => {
      const requestKey_0 = t20 === undefined ? "patchLightCourseLecture" : t20;
      return await patchLightCourseLectureFetcher(getLightCourseUpdateLecturePath(id_1), lecture_0, undefined, requestKey_0);
    };
    $[29] = patchLightCourseLectureFetcher;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  const patchLightCourseLecture = t19;
  let t20;
  if ($[31] !== activateLightCourseLecture || $[32] !== createLightCourse || $[33] !== createLightCourseLecture || $[34] !== createLightCourseLectureWithDefaultValues || $[35] !== createLightCourseModule || $[36] !== createLightCourseWithDefaultValues || $[37] !== deleteLightCourseLecture || $[38] !== patchLightCourseLecture || $[39] !== patchLightCourseOptions || $[40] !== updateLightCourseLecture || $[41] !== updateLightCourseModule) {
    t20 = {
      createLightCourse,
      createLightCourseWithDefaultValues,
      patchLightCourseOptions,
      createLightCourseModule,
      updateLightCourseModule,
      createLightCourseLecture,
      createLightCourseLectureWithDefaultValues,
      deleteLightCourseLecture,
      activateLightCourseLecture,
      updateLightCourseLecture,
      patchLightCourseLecture
    };
    $[31] = activateLightCourseLecture;
    $[32] = createLightCourse;
    $[33] = createLightCourseLecture;
    $[34] = createLightCourseLectureWithDefaultValues;
    $[35] = createLightCourseModule;
    $[36] = createLightCourseWithDefaultValues;
    $[37] = deleteLightCourseLecture;
    $[38] = patchLightCourseLecture;
    $[39] = patchLightCourseOptions;
    $[40] = updateLightCourseLecture;
    $[41] = updateLightCourseModule;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
};